import { render, staticRenderFns } from "./MobileNews4.vue?vue&type=template&id=4716cfa8&scoped=true&"
import script from "./MobileNews4.vue?vue&type=script&lang=ts&"
export * from "./MobileNews4.vue?vue&type=script&lang=ts&"
import style0 from "./MobileNews4.vue?vue&type=style&index=0&id=4716cfa8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4716cfa8",
  null
  
)

export default component.exports